export { default } from './posts-navigator';
